import { TYPES } from 'action-types/vendors';
import * as msgs from '../../constants/validationMessages';
import {
    IVendorsModel,
} from 'reducers/vendors/models';

export interface IVendorsAction {
    readonly type: string;
    readonly errors?: string|string[];
    readonly vendors: IVendorsModel[];
}

export interface IVendorsState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string | string[];
    readonly vendors: IVendorsModel[];
}

export const defaultState: IVendorsState = {
    isFetchDataError:false,
    pendingError: '',
    isFetchDataLoading: false,
    vendors: []
};

export const reducer = (state: IVendorsState = defaultState, action: IVendorsAction): IVendorsState => {
    switch (action.type) {
        case TYPES.FETCH_VENDORS.PENDING:
        case TYPES.RESET_VENDORS.PENDING:
            return {
                ...state,
                vendors: defaultState.vendors,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: ''
            };
        case TYPES.FETCH_VENDORS.FULFILLED:
            return {
                ...state,
                vendors: action.vendors,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: action.vendors && action.vendors.length > 0 ? '': msgs.ExtraDocument.Pending_Error,
            };
        case TYPES.FETCH_VENDORS.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: action.errors && action.errors.length ?action.errors.toString(): msgs.ExtraDocument.Error_Msg
            };
        default:
            return state;
    }
};
